var poiGoogleMapInit;

(function ($) {

	const selectors = {
		wrap: '[data-poi-map]',
		map: '[data-poi-map-map]',
		link: '[data-poi-map-filter]',
		marker: '[data-poi-map-marker]'
	}


	poiGoogleMapInit = function () {
		$(selectors.wrap).each((i, el) => {
			new PoiGoogleMap(el);
		});
	}

	class PoiGoogleMap {
		constructor(element) {

			this.$wrap = $(element);

			if (this.$wrap.length) {
				this.init();
			}

		}
		init() {

			this.$map = $(selectors.map, this.$wrap);
			if (!this.$map.length) return;

			this.$links = $(selectors.link, this.$wrap);

			this.createMap();
			this.addMarkers();
			this.bind();

			this.$links.eq(0).trigger('click');

		}

		bind() {
			const self = this;
			this.onLinkClicked = this.onLinkClicked.bind(this);
			this.$links.on('click', function (e) { self.onLinkClicked(e, this) });
		}

		createMap() {

			const self = this;
			self.max_zoom = 15;

			var latLng = {
				lat: parseFloat(self.$map.attr('data-lat')),
				lng: parseFloat(self.$map.attr('data-lng'))
			};

			// Create gerenic map.
			var mapArgs = {
				zoom: self.$map.data('zoom') || self.max_zoom,
				maxZoom: self.max_zoom,
				center: latLng,
				mapTypeId: self.$map.attr('data-type') || 'roadmap',
				styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
			};

			self.googleMap = new google.maps.Map(self.$map[0], mapArgs);

			// Create marker instance.
			self.mainMarker = new google.maps.Marker({
				position: latLng,
				map: self.googleMap,
				cursor: 'default',
				icon: {
					url: wp_params.theme_url + '/assets/img/map-marker-investment.svg?v=1.1',
					size: new google.maps.Size(261, 134),
					anchor: new google.maps.Point(52, 110)
				}
			});

		}

		addMarkers() {
			const self = this;

			self.markers = {};

			$(selectors.marker, self.$wrap).each((i, marker) => {

				var cat = $(marker).attr('data-category');

				if (!self.markers[cat]) self.markers[cat] = [];

				var latLng = {
					lat: parseFloat($(marker).attr('data-lat')),
					lng: parseFloat($(marker).attr('data-lng'))
				};

				var _marker = new google.maps.Marker({
					position: latLng,
					cursor: 'default',
					icon: {
						url: wp_params.theme_url + '/assets/img/map-marker.svg',
						size: new google.maps.Size(24, 31),
						anchor: new google.maps.Point(12, 31)
					}
				});

				if ($(marker).html().trim().length) {

					var infowindow = new google.maps.InfoWindow({
						content: $(marker).html()
					});

					google.maps.event.addListener(_marker, 'mouseover', function () {
						infowindow.open(self.googleMap, _marker);
						document.activeElement.blur();
						return false;
					});
					google.maps.event.addListener(_marker, 'mouseout', function () {
						infowindow.close(self.googleMap, _marker);
						document.activeElement.blur();
						return false;
					});

				}

				self.markers[cat].push(_marker);
			});


		}


		onLinkClicked(e, link) {
			e.preventDefault();
			this.hideMarkers();
			this.showMarkers($(link).attr('data-poi-map-filter'));
			this.$links.removeClass('is-active');
			$(link).addClass('is-active');
		}

		hideMarkers() {
			const self = this;
			$.each(self.markers, (cat, markers) => {

				$.each(markers, (i, marker) => {
					marker.setMap(null);
				});

			});

		}
		showMarkers(cat) {
			const self = this;
			var bounds = new google.maps.LatLngBounds();

			var loc = new google.maps.LatLng(self.mainMarker.position.lat(), self.mainMarker.position.lng());
			bounds.extend(loc);

			$.each(self.markers[cat], (i, marker) => {
				marker.setMap(self.googleMap);
				var loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
				bounds.extend(loc);
			});
			self.googleMap.fitBounds(bounds); //auto-zoom
			self.googleMap.panToBounds(bounds); //auto-center

			var zoom = self.googleMap.getZoom();
			self.googleMap.setZoom(zoom > self.max_zoom ? self.max_zoom : zoom);
		}

	}

})(jQuery);

export default poiGoogleMapInit;